(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calendly-appointment"] && !Shopify.designMode) return;
  try {
    
function initializeClassicCalendar(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const container = root.querySelector('.calendly-inline-widget');
  const buttons = root.querySelectorAll('.calendly-type-btn');
  const fallback = root.querySelector('[data-cj-calendar-fallback]');
  let activeUrl = buttons[0]?.dataset.url;
  function renderCalendar() {
    if (!window.Calendly || !activeUrl || !container.isConnected) return;
    container.replaceChildren();
    window.Calendly.initInlineWidget({url:activeUrl + (activeUrl.includes('?') ? '&' : '?') + 'background_color=fbf8f4&text_color=423731&primary_color=6b5148',parentElement:container});
  }
  buttons.forEach(button => button.addEventListener('click', () => {
    activeUrl = button.dataset.url;
    buttons.forEach(item => {
      item.classList.toggle('is-active', item === button);
      item.setAttribute('aria-pressed', String(item === button));
    });
    fallback.href = activeUrl;
    renderCalendar();
  }));
  if (window.Calendly) renderCalendar();
  else document.getElementById('cj-calendly-loader')?.addEventListener('load', renderCalendar, {once:true});
}
function initializeClassicCalendars() {
  document.querySelectorAll('[data-cj-calendar]').forEach(initializeClassicCalendar);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeClassicCalendars);
else initializeClassicCalendars();
document.addEventListener('shopify:section:load', initializeClassicCalendars);

  } catch(e) { console.error(e); }
})();
})();
